<template>
  <div class="details">
    <div class="details-left" id="selector">
      <ul class="nav nav-tabs-ul" role="tablist" :style="btnFlag?'top:60px;':'top: 150px;'">
        <li v-if="categoryList"><a :class="{active:show==='base'}" href="#base">基本信息</a></li>
        <li v-for="item in categoryList" :key="item.id">
          <a :class="{active:show===item.name}" :href="'#'+item.name">{{item.name}}</a>
        </li>
      </ul>
    </div>
    <div class="details-right" data-spy="scroll" data-target="#selector">
      <img v-if="btnFlag" class="go-top" src="../../assets/images/top.png" @click="backTop" />
      <div class="box-container">
        <div class="details-head" id="base">基本信息</div>
        <div class="details-button">
          <span class="button-click disabled">在线办理</span>
          <span class="button-click disabled">指南下载</span>
          <span class="button-click disabled">在线预约</span>
          <span class="button-click disabled">
            <i class="fa fa-heart"></i>收藏
          </span>
          <span class="button-click disabled">在线评价</span>
        </div>
        <div class="details-form">
          <table class="table-bordered">
            <tr>
              <th>名称</th>
              <td colspan="3">{{msgData.name}}</td>
              <!-- <th>电话</th>
              <td>{{msgData.phone}}</td> -->
            </tr>
            <tr>
              <th>官网地址</th>
              <td>
                <a target="_blank" :href="msgData.webUrl">{{msgData.webUrl}}</a>
              </td>
              <th>证书编号</th>
              <td>{{msgData.cerNumber}}</td>
            </tr>
            <tr>
              <th>证书状态</th>
              <td>{{msgData.cerState}}</td>
              <th>发证日期</th>
              <td>{{msgData.issueDate}}</td>
            </tr>
             <tr>
              <th>数据上报日期</th>
              <td>{{msgData.reportDate}}</td>
              <th>有效日期</th>
              <td>{{msgData.validEndDate}}</td>
            </tr>
             <tr>
              <th>所属系统</th>
              <td>{{msgData.ownSystem}}</td>
              <th>发证机关</th>
              <td>{{msgData.licenceOrg }}</td>
            </tr>
             <tr>
              <th>联系人</th>
              <td>{{msgData.contact}}</td>
              <th>联系电话</th>
              <td>{{msgData.phone}}</td>
            </tr>
            <tr>
              <th>机构地址</th>
              <td colspan="3">{{msgData.address }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div v-for="item in categoryList" :key="item.id" :id="item.name" class="box-container">
        <div class="details-head">{{item.name}}</div>
        <div class="details-words" v-for="element in calOrgServiceList" :key="element.id">
          <span class="words-block">{{element.name}}</span>
          <span><a :href="element.webUrl">{{element.webUrl}}</a></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'metroloyDetail',
  components: {},
  data () {
    return {
      btnFlag: '',
      msgData: '',
      categoryList: [],
      calOrgServiceList: [],
      show: ''
    };
  },
  created () {
    window.scrollTo(0, 0);
  },
  computed: {
    detailId: function () {
      return window.localStorage.getItem('id')
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop);
    this.fetchList();
    $('body').scrollspy({ target: '#selector' });
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop);
  },
  methods: {
    fetchList () {
      this.msgData = []
      this.categoryList = []
      let url = '/ins/insOrgan/info/' + this.detailId;
      this.verify('fetch', url, {}, res => {
        this.msgData = res.data;
        this.categoryList = res.data.categoryList;
        this.inintCalOrgServiceList()
      });
    },
    inintCalOrgServiceList () {
      this.getCalOrgServiceList(this.categoryList[0])
    },
    getCalOrgServiceList (item) {
      this.calOrgServiceList = item.calOrgServiceList;
    },
    backTop () {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    scrollToTop () {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 180) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
.details {
  position: relative;
  width:1160px;
  margin: 0 auto;
  .details-left {
    .nav-tabs-ul {
      width: 150px;
      left: 50%;
      position: fixed;
      margin-left: -725px;
      transition: all .3s;
    }
    .nav-tabs-ul li {
      width: 150px;
      font-size: 14px;
      height: 40px;
      text-align: right;
      line-height: 40px;
      cursor: pointer;
      &.active {
        font-size: 20px;
        font-weight: bold;
        a {
          color: @color-base;
        }
      }
    }
    .nav-tabs-ul li a {
      display: inline-block;
      width: 150px;
      vertical-align: middle;
      line-height: 22px;
      color: #666666;
    }
  }
  .details-right {
    position: relative;
    .box-container {
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.10);
      margin-top: 20px;
      padding: 0 20px 20px;
    }
    .actives {
      border-left: 4px solid @color-base;
    }
    .details-head {
      padding-left: 32px;
      line-height: 60px;
      background:rgba(200,228,255);
      font-size: 24px;
      font-weight: 600;
      color:rgba(0,0,0,0.85);
      margin: 0 -20px;
      border-left: 4px solid @color-base;
      border-bottom: 1px solid rgba(@color-base, 0.20);
    }
    .details-button {
      line-height: 74px;
      .button-click {
        display: inline-block;
        background: rgba(0, 141, 255, 0.1);
        font-weight: 400;
        color: @color-base;
        cursor: pointer;
        width: 120px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        .fa {
          margin-right: 6px;
        }
        &.disabled {
          background-color: #F8F8F8;
          color: #ccc;
          cursor: default;
        }
      }
    }
    .details-form {
      table {
        width: 100%;
        a{
          color: @color-base;
        }
        tr {
          td {
            width: 280px;
            padding-left: 24px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            line-height: 60px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.84);
          }
          th {
            padding-left: 24px;
            width: 180px;
            background:rgba(0,0,0,0.05);
            border: 1px solid rgba(0, 0, 0, 0.1);
            line-height: 60px;
            font-size: 14px;
            font-weight: 600;
            color: #000;
          }
        }
      }
    }
    .details-word {
      padding: 30px 60px;
      span {
        display: block;
        font-size: 16px;
        font-weight: 400;
        color: #000;
        line-height: 32px;
      }
    }
    .go-top {
      cursor: pointer;
      position: fixed;
      right: 0;
      bottom: 120px;
    }
    .details-words:hover {
      cursor:pointer;
      box-shadow: 0 6px 10px 0 rgba(0, 141, 255, 0.1);
      border: 1px solid rgba(0, 141, 255, 0.1);
    }
    .details-words {
      height: 104px;
      padding: 20px 20px 20px 40px;
      .words-block {
        display: block;
      }
      span {
        font-size: 16px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.84);
        line-height: 32px;
      }
      .word-time {
        float: right;
      }
    }
    .frame-box {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/detail/testDetail.vue